/**
 * Numeric percent input (0-100) with right-anchored "%" suffix. Clamps on
 * change so the campaign settings never send out-of-range values.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

export interface BinomPercentInputProps {
  value: number | undefined;
  onChange: (next: number) => void;
  ariaLabel: string;
}

const BinomPercentInput: FC<BinomPercentInputProps> = ({
  value,
  onChange,
  ariaLabel,
}) => (
  <div className="inline-flex h-7 w-24 items-center rounded border border-input bg-background px-1 focus-within:ring-1 focus-within:ring-ring">
    <input
      type="number"
      min={0}
      max={100}
      value={value ?? 0}
      onChange={(e) => {
        const parsed = Number(e.target.value);
        if (!Number.isFinite(parsed)) return;
        onChange(Math.max(0, Math.min(100, Math.round(parsed))));
      }}
      className="min-w-0 flex-1 bg-transparent py-0 text-right text-xs tabular-nums outline-none"
      aria-label={ariaLabel}
    />
    <span className="ml-px shrink-0 text-[10px] font-semibold leading-none text-muted-foreground">
      %
    </span>
  </div>
);

export default BinomPercentInput;
